<template>
  <div class="store-item-options">
    <fieldset
      v-for="(option, optionIndex) in options"
      :key="optionIndex"
    >
      <store-item-option
        :option="option"
        :item="item.item"
        :show-errors="showErrors"
        @loading="onLoading"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import StoreItemOption from './StoreItemOption.vue';

export default {
  components: {
    StoreItemOption,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array<any>,
      default: () => [],
    },

    showErrors: {
      type: Boolean,
      default: () => false,
    },
  },
  emits: ['loading'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const onLoading = (value: boolean) => {
      emit('loading', value);
    };

    return {
      onLoading,
    };
  },
};
</script>

<style lang="scss">
.store-item-options {
  input[type='number'] {
    width: 75px;
  }

  .limit-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .input-amount.el-input {
    width: auto;
    margin: 0 10px 10px 0;
  }

  .input-error {
    color: red;
  }

  .input-amount.invalid input {
    border-color: red;
  }
}
</style>
